import React from 'react';
import { connect } from 'react-redux';
import { useForm, FormProvider } from 'react-hook-form';
import { IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { RMSTextField } from '../features/shared/components/form-controls';
import { RMSButton } from '../features/shared/components/buttons';
import { submitLoginForm } from '../reducers/UserReducer';

const PageEvidenceScanLogin = ({ submitLoginForm }) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const methods = useForm({ defaultValues: { username: '', password: '' } });

  const handleSignIn = methods.handleSubmit(({ username, password }) => {
    submitLoginForm(username, password);
  });

  return (
    <div className="evidence-scan-page">
      <div className="evidence-scan-page-header">
        <div className="evidence-scan-page-brand">
          <div className="evidence-scan-page-title">PTS Evidence</div>
          <div className="evidence-scan-page-subtitle">Mobile Scan In/Out</div>
        </div>
      </div>

      <div className="evidence-scan-login-body">
        <div className="evidence-scan-login-card">
          <div className="evidence-scan-login-card-header">
            <div className="evidence-scan-login-card-title">Sign In</div>
            <div className="evidence-scan-login-card-subtitle">Enter your PTS credentials</div>
          </div>

          <div className="evidence-scan-login-card-body">
            <FormProvider {...methods}>
              <form onSubmit={handleSignIn}>
                <div className="evidence-scan-login-field">
                  <div className="evidence-scan-login-label">Username</div>
                  <RMSTextField
                    name="username"
                    className="evidence-scan-login-input"
                    placeholder="PTS username"
                    autoComplete="username"
                    autoFocus
                  />
                </div>

                <div className="evidence-scan-login-field">
                  <div className="evidence-scan-login-label">Password</div>
                  <RMSTextField
                    name="password"
                    className="evidence-scan-login-input"
                    placeholder="Enter your password"
                    autoComplete="current-password"
                    type={showPassword ? 'text' : 'password'}
                    rightContent={() => (
                      <IconButton
                        className="evidence-scan-login-eye-btn"
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword((prev) => !prev)}
                        onMouseDown={(event) => event.preventDefault()}
                        size="small">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    )}
                  />
                </div>

                <RMSButton
                  type="submit"
                  label="Sign In"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className="evidence-scan-login-submit"
                />
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(null, { submitLoginForm })(PageEvidenceScanLogin);
